import { Button, Grid } from "@mui/material";
import React, { useLayoutEffect, useMemo, useRef, useState } from "react";
import { DialogKldrProps, HTMLGridPanelElement } from "../../../ComponentInterface";
import smetaAxios from "../../../SmetaAxios";
import { GridLoader } from "../../rcsgrid/createGridTools";
import { createGrid, createRecordSource } from "../../rcsgrid/rcsgrid";
import { Prefixes } from "../../Tools/ProjectX";
import { localization } from "../../Tools/Tools";

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function DialogKldr(props: DialogKldrProps) {
  const [mainGrid, setMainGrid] = useState<{ grid: createGrid; source: createRecordSource }>();
  const [timer, setTimer] = useState<NodeJS.Timeout>();

  //ссылка на компонент для таблицы
  const gridpanelRef = useRef<HTMLGridPanelElement>(null!);

  //временное объявление для работы запроса SetAddress
  //создаем в памяти константу чтобы один раз изменить ее если отсутствует CurrentID у адреса
  const propsData = useMemo(() => {
    return { ...props.data };
  }, []);

  //запрос посимвольной фильтрации
  function filtration(filter: string) {
    return smetaAxios.get("setFilter", {
      prefix: Prefixes.kladr,
      params: { Filter: filter, ObjType: props.ObjType },
      loadMask: true,
    });
  }

  useLayoutEffect(() => {
    GridLoader(gridpanelRef.current, props).then((res) => {
      setMainGrid(res);
    });
  }, []);

  //запрос для получения параметров для запроса setParamProperty
  function resumeRequest(request) {
    return smetaAxios.post("ResumeRequest", request, {
      prefix: Prefixes.default,
      params: { RequestID: props.RequestID, WSM: "1" },
      loadMask: true,
    });
  }
  //создание запроса(request) для resumeRequest
  function getRequestJson() {
    const source: createRecordSource = gridpanelRef.current.grid.source;
    const code = source.getFieldTextSync("Code");
    const name = source.getFieldTextSync("Name");
    const short = source.getFieldTextSync("Socr");
    const guid = source.getFieldTextSync("GUID");
    if (propsData.FieldName === "BulkNo" || propsData.FieldName === "BuildNo") {
      propsData.FieldName = "House";
    }
    return {
      Result: "1",
      Code: code,
      Classificator: { Классификатор: code },
      [propsData.FieldName]: {
        [localization()[propsData.FieldName]]: name,
        Сокращение: short,
        Код: code[0] + "" + code[1],
      },
      GUID: { Идентификатор: guid },
    };
  }

  //функция для установки новго значения для параметра
  async function onSelect() {
    const json = await resumeRequest(getRequestJson());
    if (json.NeedRefresh === "1") {
      props.func?.(json);
    } else {
      propsData.onEdit?.({
        kladr: true,
        json: json,
        objref: propsData.ObjRef,
      });
    }
  }

  //установка нового значения для полей адреса House

  return (
    <>
      {/* {Основной контейнер} */}
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="flex-end"
        style={{ height: "100%", width: "100%" }}
      >
        {/* {Контейнер для Таблицы} */}
        <Grid
          id="rcgrid_panel"
          ref={gridpanelRef}
          item
          style={{
            position: "relative",
            height: "calc(100% - 40px)",
            width: "100%",
          }}
        />
        {/* {Контейнер для Поиска и кнопок} */}
        <Grid item style={{ height: "40px", width: "100%" }}>
          <Grid container direction="row" justifyContent="flex-start" alignItems="center">
            {/* {Поиск} */}
            <Grid item style={{ margin: "8px", width: "calc(100% - 182px)" }}>
              <Grid container direction="row" justifyContent="flex-end" alignItems="center">
                <div style={{ width: "62px" }}>
                  <span>Поиск:</span>
                </div>
                <input
                  style={{
                    width: "calc(100% - 62px)",
                    outline: "0",
                  }}
                  onChange={(ev) => {
                    clearTimeout(timer);
                    setTimer(
                      setTimeout(async () => {
                        await filtration(ev.target.value === undefined ? "" : ev.target.value);
                        if (mainGrid) {
                          await mainGrid.grid.refreshSource();
                        }
                      }, 200),
                    );
                  }}
                  title="Filter"
                />
              </Grid>
            </Grid>
            <Grid item style={{ width: "164px" }}>
              <Grid container direction="row" justifyContent="flex-end" alignItems="center">
                <Button
                  size="small"
                  variant="outlined"
                  style={{ textTransform: "none", marginRight: "10px" }}
                  value="1"
                  className="button_Modal_Select"
                  onClick={onSelect}
                >
                  Выбрать
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  style={{ textTransform: "none" }}
                  value="2"
                  className="button_Modal_Close"
                >
                  Отмена
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
